import React from 'react';

const BootstrapRow = ({className, style, children }) =>
{
	const classAdd =  className !== undefined ? ' ' + className : '' ;

	return <div className={'row' + classAdd} style={style}>{children}</div>
}

export default BootstrapRow ;